import React from 'react';
import './Banner.css';

function Banner({ isOpen, onClose, title, message, linkText, linkUrl, backgroundImage }) {
  if (!isOpen) return null;

  return (
    <div className="banner-overlay">
      <div className="banner-content">
        {backgroundImage && (
          <img src={backgroundImage} alt="Banner" className="banner-image" />
        )}
        <button className="banner-close-btn" onClick={onClose}>
          ✕
        </button>
        <div className="banner-text">
          {title && <h2 className="banner-title">{title}</h2>}
          {message && <p className="banner-message">{message}</p>}
          {linkText && linkUrl && (
            <a href={linkUrl} target="_blank" rel="noopener noreferrer" className="banner-link">
              {linkText}
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default Banner;
